module.exports = __webpack_public_path__ + "static/media/YM25_0.823c18cc.jpg";